import React from 'react';
import { observer } from 'mobx-react-lite';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { debounce } from '../../../jira-common/utils/CommonUtils';
import { FormQuestionType } from '../../models/Form';
import { toUserPickerQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditUserPicker } from './edit/EditUserPicker';
import { ViewUserPicker } from './view/ViewUserPicker';
export const UserPicker = observer(({
  id,
  questionStore,
  formStore,
  displayMode
}) => {
  const isMulti = questionStore.formQuestion.type === FormQuestionType.UserMultiple;
  const value = questionStore.currentAnswer ? toUserPickerQuestionAnswerOrEmpty(questionStore.currentAnswer).map(item => ({
    value: item.id,
    label: item.name
  })) : null;
  const showEditComponent = displayMode === DisplayMode.Edit && !(getBooleanFF('platform.proforma-read-only-questions.wewrsr') && questionStore.formQuestion.readOnly);
  if (showEditComponent) {
    const loadOptions = debounce((inputValue, callback) => {
      const input = inputValue.trim();
      if (input) {
        var _questionStore$issueF;
        formStore.searchUsersWithFieldConfig(questionStore.formQuestion.jiraField, (_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.fieldConfigId, input).then(results => {
          callback(results);
        }).catch(error => {
          callback([]);
        });
      } else {
        callback([]);
      }
    }, 500);
    const onChange = newValue => {
      let values;
      if (!newValue) {
        values = [];
      } else if (isMulti) {
        values = newValue.map(item => {
          return {
            id: item.value,
            name: item.label
          };
        });
      } else {
        values = [{
          id: newValue.value,
          name: newValue.label
        }];
      }
      questionStore.setAnswer(values);
    };
    return /*#__PURE__*/React.createElement(EditUserPicker, {
      id: id,
      isMulti: isMulti,
      value: value,
      loadOptions: loadOptions,
      onChange: onChange,
      isInvalid: !!questionStore.validationErrors
    });
  }
  return /*#__PURE__*/React.createElement(ViewUserPicker, {
    id: id,
    isMulti: isMulti,
    value: value,
    displayMode: displayMode
  });
});